import React, { useState } from "react";
import PasswordVisibilityToggle from "./PasswordVisibilityToggle";

const PasswordInput = ({
  label,
  required = false,
  error,
  touched,
  className = "",
  inputClassName = "",
  value,
  onChange,
  onBlur,
  name,
  placeholder,
  id,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const hasError = touched && error;
  const inputId = id || name || `password-input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <div className="relative">
        <input
          id={inputId}
          type={showPassword ? "text" : "password"}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete="off"
          placeholder={placeholder}
          className={`w-full px-4 pr-10 py-3 rounded-lg text-sm text-secondary placeholder-gray-400 
            focus:outline-none focus:ring-2 focus:ring-secondary focus:border-secondary transition-colors
            ${hasError ? "border-red-300 bg-red-50" : "bg-grey"}
            ${inputClassName}`}
        />

        <div className="absolute right-3 top-1/2 -translate-y-1/2">
          <PasswordVisibilityToggle isVisible={showPassword} onToggle={() => setShowPassword(!showPassword)} />
        </div>
      </div>

      {hasError && <p className="mt-1.5 text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default PasswordInput;
